import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';

interface UnderConstructionProps {
	featureName?: string;
	message?: string;
}

const UnderConstruction: React.FC<UnderConstructionProps> = ({ featureName = 'This feature', message }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minHeight: '400px',
				width: '100%',
			}}
		>
			<Paper
				elevation={0}
				sx={{
					padding: 4,
					textAlign: 'center',
					backgroundColor: 'transparent',
				}}
			>
				<ConstructionIcon
					sx={{
						fontSize: 80,
						color: 'text.secondary',
						opacity: 0.5,
						mb: 2,
					}}
				/>
				<Typography variant="h5" color="text.secondary" gutterBottom>
					{featureName} is Under Construction
				</Typography>
				{message && (
					<Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
						{message}
					</Typography>
				)}
			</Paper>
		</Box>
	);
};

export default UnderConstruction;
